// Shared constants for the Corrections review loop.
export const CATEGORIES = [
  ["product_configuration", "Product Configuration"], ["pricing", "Pricing"],
  ["forms", "Forms"], ["user_access", "User Access"],
  ["dealer_information", "Dealer Information"], ["eligibility", "Eligibility"],
  ["contract_generation", "Contract Generation"], ["reporting", "Reporting"],
  ["ach", "ACH"], ["documents", "Documents"], ["other", "Other"],
];

export const PRIORITIES = [["normal", "Normal"], ["high", "High"], ["critical", "Critical"]];

export const STATUS_META = {
  open:        { label: "Open",        tone: "bg-red-50 text-red-700 border-red-200" },
  in_progress: { label: "In Progress", tone: "bg-yellow-50 text-yellow-800 border-yellow-200" },
  corrected:   { label: "Corrected",   tone: "bg-blue-50 text-blue-700 border-blue-200" },
  verified:    { label: "Verified",    tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  reopened:    { label: "Reopened",    tone: "bg-red-50 text-red-700 border-red-200" },
};

export const emptyItem = () => ({
  issue_title: "", description: "", category: "product_configuration", priority: "normal",
});
